import { Link } from "react-router-dom";
import { Zap, Sparkles, Trophy, ShieldCheck } from "lucide-react";

export default function HowItWorks() {
  return (
    <div className="max-w-5xl mx-auto px-5 md:px-8 py-12 md:py-20" data-testid="how-it-works-page">
      <div className="text-[10px] uppercase tracking-[0.22em] text-[color:var(--ufr-green)] font-bold">Skill-based</div>
      <h1 className="font-display text-4xl md:text-6xl text-white mt-2">How UFR works</h1>
      <p className="text-white/70 mt-4 max-w-2xl">
        UFR is a skill-based competition platform — not a lottery. Every raffle requires a correct trivia answer
        before payment. This is what makes our competitions legal across the UK and most jurisdictions.
      </p>

      <div className="grid md:grid-cols-2 gap-5 mt-10">
        <Card icon={<Zap size={22} />} n="01" title="Pick a raffle"
              text="Browse live football card raffles — autos, refractors, parallels, vintage. Each card has a fixed ticket pool and ends at a set draw date." />
        <Card icon={<Sparkles size={22} />} n="02" title="Answer the trivia"
              text="A multiple-choice football question is gated in front of every checkout. Correct answer = you qualify to enter. Get it wrong? Try again — no charge." />
        <Card icon={<Trophy size={22} />} n="03" title="Buy your tickets"
              text="Choose how many tickets you want (up to the per-raffle limit). Secure card payment is coming soon. Each ticket is numbered and locked to your account." />
        <Card icon={<ShieldCheck size={22} />} n="04" title="Live draw + ship"
              text="Once the timer hits zero we run a live, transparent draw. Winners are notified immediately and slabbed cards ship insured & tracked." />
      </div>

      <div className="ufr-card rounded-md p-8 mt-12">
        <h2 className="font-display text-2xl text-white">FAQ</h2>
        <div className="space-y-5 mt-5">
          <Faq q="Is this gambling?" a="No. Every entry requires a correct skill-based answer, making UFR a legal skill competition under UK Gambling Act 2005 free draw / skill provisions." />
          <Faq q="What if I get the answer wrong?" a="You can retry — no money is taken until you've answered correctly and chosen your tickets." />
          <Faq q="When are draws held?" a="Each raffle ends at the timer shown on the card detail page. Draws are run live as soon as the timer hits zero." />
          <Faq q="How do I get my prize?" a="If you win, we email you within 1 hour. Cards ship within 48 hours via tracked, insured delivery." />
        </div>
      </div>

      <div className="mt-12 text-center">
        <Link to="/competitions" className="btn-ufr-primary inline-block px-8 py-4 text-sm">Browse live raffles</Link>
      </div>
    </div>
  );
}

function Card({ icon, n, title, text }) {
  return (
    <div className="ufr-card rounded-md p-6">
      <div className="flex items-center justify-between">
        <div className="text-[color:var(--ufr-green)]">{icon}</div>
        <div className="font-display text-5xl text-white/10">{n}</div>
      </div>
      <div className="font-display text-2xl text-white mt-3">{title}</div>
      <p className="text-white/60 text-sm mt-2">{text}</p>
    </div>
  );
}

function Faq({ q, a }) {
  return (
    <div>
      <div className="font-bold text-white">{q}</div>
      <div className="text-white/60 text-sm mt-1">{a}</div>
    </div>
  );
}
